import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {EventService} from '../../../../core/services/event.service';
import moment from 'moment';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'edit-guest-data',
    templateUrl: './editGuestData.html',
    styleUrls: ['./editGuestData.scss'],
    standalone: false
})

export class EditGuestData implements OnInit{

  public form1: FormGroup = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    gender: new FormControl('', Validators.required),
    street: new FormControl('', Validators.required),
    number: new FormControl('', Validators.required),
    postcode: new FormControl('', Validators.required),
    orgName: new FormControl(''),
    bookedFromOrgId: new FormControl(''),
    cityName: new FormControl(''),
    id: new FormControl(''),
    groupRegistration: new FormControl(''),
    nameOfOrganization: new FormControl('', Validators.required),
    numberOfPeople: new FormControl(1, Validators.required)
  });
  public settingForm: FormGroup = new FormGroup({});
  showGroupRegistration = false;

  allGuestSettings: any = {};
  mobileError = false;

  titleComments: any = {};
  expiry_date;
  eventOrganization = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private userService: FrontUserService,
              public eventService: EventService,
              public dialogRef: MatDialogRef<EditGuestData>, public toastr: ToastrService) {

  }

  ngOnInit(): void {
    this.getTableInfoById();
    this.getEventOrganization();
    if (this.data.event.titleComments && this.data.event.titleComments.length) {
      this.titleComments = JSON.parse(this.data.event.titleComments);
    }
    this.form1.get('groupRegistration').valueChanges.subscribe((res: any) => {
      if (res) {
        this.showGroupRegistration = true;
      } else {
        this.showGroupRegistration = false;
      }
    });
    if (this.data.user) {
      this.form1.patchValue(this.data.user);
      if (this.data.user.guestUserId) {
        this.form1.patchValue({id: +this.data.user.guestUserId});
      }
    }
  }

  get f() {
    return this.form1.controls;
  }

  get fs() {
    return this.settingForm.controls;
  }

  isRequiredField(field: string) {
    const form_field = this.settingForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return validator && validator.required;
  }

  getTableInfoById() {
    this.eventService
      .getTableInfoById(this.data.event.guestData)
      .subscribe((res: any) => {
        let rowObject = {};
        res.forEach((el: any) => {
          if (!rowObject[el.title]) {
            rowObject[el.title] = {};
            rowObject[el.title][el.name] = el;
          } else {
            rowObject[el.title][el.name] = el;
          }
          let _required = [];
          if (this.data.event.requiredGF) {
            _required = this.data.event.requiredGF.split(',');
            _required = _required.map(data => +data);
          }
          if (
            _required &&
            _required.length &&
            _required.indexOf(+el.id) !== -1
          ) {
            this.settingForm.addControl(
              el.name,
              new FormControl('', Validators.required)
            );
          } else {
            this.settingForm.addControl(el.name, new FormControl(''));
          }
        });
        this.allGuestSettings = Object.assign(rowObject);
        if (this.data.user.data) {
          let userData = this.data.user.frontUserId ? JSON.parse(this.data.user.data.data)
            : JSON.parse(this.data.user.data);
          if (userData.passport) {
            let _passportData = userData.passport.split(' ');
            if (_passportData.length >= 2) {
              userData.passport = _passportData[0];
              this.expiry_date = _passportData[1];
            }
          }
          this.settingForm.patchValue(userData);
        }
      });
  }

  confirm() {
    if ((this.form1.valid && !this.data.user.frontUserId && this.settingForm.valid) ||
      (this.data.user.frontUserId && this.settingForm.valid)) {
      let _form = this.form1.value;
      if (this.settingForm.value && this.settingForm.value.mobile) {
        _form.phone = this.settingForm.value.mobile;
      }
      if (!this.data.user.frontUserId){
        this.eventService.guestUsers(_form).subscribe((result: any) => {
          if (result && result.id) {
            let setForm = Object.assign(this.settingForm.value);

            if (setForm.hasOwnProperty('passport')) {
              setForm.passport =
                setForm.passport.replace(/ /g, '') + ' ' + moment(this.expiry_date).format();
            }
            let body = {
              userId: result.id,
              data: JSON.stringify(setForm),
              isFrontUser: false,
              eventId: this.data.event.id
            };
            this.eventService.guestData(body).subscribe(resEnd => {
              this.toastr.success('Data saved' , 'Success!');
              this.dialogRef.close(true);
            });
          }
        });
      } else {
        let setForm = Object.assign(this.settingForm.value);

        if (setForm.hasOwnProperty('passport')) {
          setForm.passport =
            setForm.passport.replace(/ /g, '') + ' ' + moment(this.expiry_date).format();
        }
        let body = {
          userId: this.data.user.frontUserId,
          data: JSON.stringify(setForm),
          isFrontUser: true,
          eventId: this.data.event.id
        };
        if (this.data.event.guestEvent) {
          this.eventService.guestData(body).subscribe(resEnd => {
          });
        }
        if (this.data.event.additionalForm) {
          this.eventService.addAdditionalData(body).subscribe(resEnd => {
          });
        }
        this.toastr.success('Data saved' , 'Success!');
        this.dialogRef.close(true);
      }

    } else {
      Object.keys(this.form1.controls).forEach(field => {
        const control = this.form1.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      Object.keys(this.settingForm.controls).forEach(field => {
        const control = this.settingForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      let modal = document.getElementById('guestModal');
      if (modal) {
        modal.scrollTop = 0;
      }
    }
  }

  getEventOrganization() {
    console.log(this.data.event.id);
    this.eventService.getEventOrganization(this.data.event.id, this.data.event.organizationId).subscribe((res: any) => {
      this.eventOrganization = res;
    });
  }
}
